import $ from 'jquery';

// change header styles on scroll
$(document).ready(function () {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 50) {
      $('.header').addClass('scrolled');
    } else {
      $('.header').removeClass('scrolled');
    }
  });

  $( ".menu-item-has-children" ).hover(
    function() {
      $('.header').addClass('scrolled');
    }, function() {
      $('.header').removeClass('scrolled');
    }
  );

});

// toggle menu icon
$(".mobile-menu-toggle").click(function () {
  $(this).toggleClass("toggled");
  $('body').toggleClass("no-scroll");
  $('.header').toggleClass("menu-toggled");

  if ($(this).hasClass('toggled')) {
    $(this).find("use").attr("xlink:href", "#icon-cross");
  } else {
    $(this).find("use").attr("xlink:href", "#menu-toggle");
  }
  
});

// share URL button
// TODO: need to add visual feedback

var shareBtn = document.querySelector(".share-copy");

shareBtn.addEventListener('click', function (event) {
  var dummy = document.createElement('input'),
    text = window.location.href;

  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand('copy');
  document.body.removeChild(dummy);

  event.preventDefault;
});

$(".prose a").attr("target", "_blank");
$(".prose a").attr("rel", "noreferrer noopener");

$(document).ready(function () {
  $('.svg-wave').on('inview', function (event, isInView) {
    if (isInView) {
      $('.svg-wave').addClass("verve-animated");
    } else {
      $('.svg-wave').removeClass("verve-animated");
    }
  });
});
